import React, { useEffect, useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { SelectWithOptions } from '@Local/Components';
import clsx from 'clsx';
import useMemberInbodyApi from '@Apis/useMemberInbodyApi';
import useEmployeeInbodyApi from '@Apis/useEmployeeInbodyApi';
import { isEmpty, localUser } from '@Util/utils';
import { MEMBER_SITE_LOGON_TYPE } from "@Constants/dataEnums";


import { Typography, IconButton, Icons } from '@curves/ui-base';
const MeasurementDateController = ({ className, setMeasureID }) => {
    const { getMemberInbodyOptionsApi } = useMemberInbodyApi();
    const { getEmployeeInbodyOptionsApi } = useEmployeeInbodyApi();
    const [options, setOptions] = useState(null);
    const { measureOption = [] } = options || {};
    const [selectedIndex, setSelectedIndex] = useState(0);
    const keyRef = useRef(uuid());

    const { logonType } = localUser.get() || {};

    const getOptionsApi = async () => {
        const resp =
            logonType === MEMBER_SITE_LOGON_TYPE.MEMBER
                ? await getMemberInbodyOptionsApi()
                : logonType === MEMBER_SITE_LOGON_TYPE.EMPLOYEE
                    ? await getEmployeeInbodyOptionsApi() : null;
        if (resp) {
            setOptions(resp);
        }
    };

    const handlePrevClick = () => {
        if (selectedIndex === measureOption.length - 1) alert('已經是最後一筆');
        else {
            setSelectedIndex((prev) => prev + 1);
        }
    };

    const handleNextClick = () => {
        if (selectedIndex === 0) alert('已經是第一筆');
        else {
            setSelectedIndex((prev) => prev - 1);
        }
    };

    const handleDateChange = (event, node, _value) => {
        measureOption.findIndex((item, index) => {
            if (item.value === _value) {
                setSelectedIndex(index);

                return true;
            }
            return false;
        });
    };

    useEffect(
        () => {
            getOptionsApi();
        },
        // eslint-disable-next-line
        [],
    );

    useEffect(
        () => {
            if (!isEmpty(measureOption) && typeof setMeasureID === 'function') {
                setMeasureID(measureOption[selectedIndex]?.value);
            }
        },
        // eslint-disable-next-line
        [measureOption, selectedIndex],
    );

    if (isEmpty(options)) return null;

    return (
        <div className={clsx('measurement-date-controller', className)}>
            <IconButton
                className={'measurement-date-controller__button measurement-date-controller__button--prev'}
                onClick={handlePrevClick}
                disabled={selectedIndex === measureOption.length - 1}
            >
                <Icons.KeyboardArrowLeft />
            </IconButton>
            <IconButton
                className={'measurement-date-controller__button measurement-date-controller__button--next'}
                onClick={handleNextClick}
                disabled={selectedIndex === 0}
            >
                <Icons.KeyboardArrowRight />
            </IconButton>
            {measureOption.length === 0 && (
                <Typography variant={'h6'} color={'error'}>無任何量身紀錄</Typography>)
            }
            {measureOption.length > 0 && (
                <SelectWithOptions
                    key={keyRef.current}
                    defaultValue={measureOption[selectedIndex]?.value}
                    className={'measurement-date-controller__select'}
                    options={measureOption}
                    onChange={handleDateChange}
                />
            )}
        </div>
    );
};

export default MeasurementDateController;
